<template>
  <div class="flex flex-wrap gap-4 mt-6">
    <Button v-if="website" :href="website" target="_blank" rel="noopener noreferrer">
      <Icon name="heroicons:globe-alt" class="mr-2 h-4 w-4" />
      Visit Website
    </Button>
    <Button
      v-if="location"
      :href="getDirectionsUrl(location)"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon name="heroicons:map" class="mr-2 h-4 w-4" />
      Get Directions
    </Button>
    <Button v-if="menuUrl" :href="menuUrl" target="_blank">
      <Icon name="heroicons:document-text" class="mr-2 h-4 w-4" />
      View Menu
    </Button>
    <Button v-if="reservationUrl" :href="reservationUrl" target="_blank">
      <Icon name="heroicons:calendar" class="mr-2 h-4 w-4" />
      Make Reservation
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'

defineProps<{
  website?: string
  location?: { lat: number; lng: number }
  menuUrl?: string
  reservationUrl?: string
}>()

const getDirectionsUrl = (location: { lat: number; lng: number }) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`
}
</script>
